import DrawingComponentContainer from './DrawingComponentContainer';

export default DrawingComponentContainer;



// WEBPACK FOOTER //
// ./src/components/atoms/DrawingComponent/index.js